<template>
    <div>
        <text-order></text-order>
    </div>
</template>

<script>
import textOrder from '../../pages/textbookOrder/textOrder.vue'
export default{
    name:'goTextbookOrder',
    components:{
        textOrder
    },

    
}
</script>


// WEBPACK FOOTER //
// src/pages/LoginIndex/goTextbookOrder.vue